export const backendOnly = () =>
    document.querySelector<HTMLMetaElement>(`meta[name="energikilden-frontend"]`)?.content === `backend-only`;

export const loginPath = () => `/login`;
